export default __webpack_public_path__ + "static/assets/im_actual_restriction.def7a8e50fb3e4638bd5c55cb4a5cf2e.png";